import styled from 'styled-components'

export const Container = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: stretch;
`
export const Main = styled.div`
  flex-grow: 1;
`
export const DashboardContainer = styled.div`
  display: flex;
  min-height: 100vh;
`
export const DashboardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: calc(100% - 6.25rem);
  left: 6.25rem;
  position: relative;
`
